// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bg-gray-100 {
  background-color: #f8f9fa !important;
}

.topbar {
  background: #000;
}

.navbar-vertical.navbar-expand-xs.fixed-left {
  left: 0;
}

.custom-col-spacing {
  margin-right: 0rem;
  /* Adjust this value to reduce space */
  margin-left: 0rem;
  /* Adjust this value to reduce space */
}

.navbar-vertical.navbar-expand-xs {
  display: block;
  position: fixed;
  top: 0;
  bottom: 0;
  width: 100%;
  max-width: 15.625rem !important;
  overflow-y: auto;
  padding: 0;
  box-shadow: none;
  background-color: #292f36;
}

.sidenav {
  z-index: 1050;
}

.main-content,
.sidenav {
  transition: all .2s ease-in-out;
}

.sidenav-header {
  height: 4.875rem;
}

.navbar-vertical .navbar-brand-img,
.navbar-vertical .navbar-brand>img {
  max-width: 100%;
  max-height: 2rem;
}

.w-15 {
  width: 15% !important;
}

.sidenav .navbar-brand {
  padding: 1.5rem 2rem;
}

.sidenav .navbar-brand,
.sidenav .navbar-heading {
  display: block;
}

.navbar .nav-link,
.navbar .navbar-brand {
  color: #252f40;
  font-size: .875rem;
}

hr.horizontal.dark {
  background-image: linear-gradient(90deg, transparent, rgba(0, 0, 0, .4), transparent);
}

hr.horizontal {
  background-color: transparent;
}

hr:not([size]) {
  height: 1px;
}

.navbar-vertical.navbar-expand-xs .navbar-collapse {
  display: block;
  overflow: auto;
}

.navbar-nav {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.navbar-vertical.navbar-expand-xs .navbar-nav>.nav-item {
  margin-top: .125rem;
}

.navbar-vertical.navbar-expand-xs .navbar-nav .nav-item {
  width: 100%;
}

.navbar-vertical .navbar-nav>.nav-item .nav-link.active {
  /* color: #000;
  background: #fde802; */
    color: #fff !important;
  background: #f40 !important;
}

/* .nav-item li{
background: #000;
} */

/* .nav-item li.active{
background: #fde802;
} */

.navbar-vertical .navbar-nav .nav-link.active {
  font-weight: 600;
  box-shadow: 0 20px 27px 0 rgba(0, 0, 0, .05);
  border-radius: .5rem;
}

.navbar-vertical.navbar-expand-xs .navbar-nav .nav-link {
  padding-top: .675rem;
  padding-bottom: .675rem;
  margin: 0 1rem;
}

.navbar-vertical .navbar-nav .nav-link {
  display: flex;
  align-items: center;
  white-space: nowrap;
  text-decoration: none;
}

.bg-color {
  background: #000;
  min-height: 100vh;
}

.header-bg {
  background: #000;
}
.card-style{
background:#565b60;
}
.navbar-vertical .navbar-nav .nav-link {
  padding-left: 1rem;
  padding-right: 1rem;
  font-weight: 600;
  color: #fff;
}

.navbar-vertical .navbar-nav>.nav-item .nav-link .icon {
  color: #000;
  /* color: linear-gradient(180deg, #E4AE75 0%, #99663A 100%); */
}


.navbar-vertical .navbar-nav>.nav-item .nav-link.active .icon {
  color: #fde802;
  /* color: linear-gradient(180deg, #E4AE75 0%, #99663A 100%); */
}

.border-radius-md {
  border-radius: .5rem;
}

.icon-sm {
  width: 32px;
  height: 32px;
}

.me-2 {
  margin-right: .5rem !important;
}

.shadow {
  box-shadow: 0 .25rem .375rem -.0625rem hsla(0, 0%, 8%, .12), 0 .125rem .25rem -.0625rem hsla(0, 0%, 8%, .07) !important;
}

.sidenav.fixed-left+.main-content {
  margin-left: 15.6rem;
}

.main-content,
.sidenav {
  transition: all .2s ease-in-out;
}

.border-radius-lg {
  border-radius: .75rem;
}

.font-weight-bolder {
  font-weight: 700 !important;
}

.sidenav .sidenav-toggler {
  width: 50px;
  float: right;
  margin-top: 2rem;
}

.sidenav-toggler .sidenav-toggler-line:last-child {
  width: 13px;
  transform: translateX(5px);
}

.sidenav-toggler-inner {
  position: relative;
}

.sidenav-toggler-inner,
.sidenav-toggler-line {
  width: 18px;
  transition: all .15s ease;
}

.sidenav-toggler .sidenav-toggler-inner::before {
  transform: scale(1);
}

.sidenav-toggler-inner::before {
  position: absolute;
  top: -14px;
  left: -11px;
  width: 40px;
  height: 40px;
  content: '';
  transition: all .15s cubic-bezier(.68, -.55, .265, 1.55);
  transform: scale(0);
  border-radius: 50%;
}

.sidenav-toggler.active .sidenav-toggler-line:first-child {
  width: 13px;
  transform: translateX(5px);
}

.sidenav-toggler-line:not(:last-child) {
  margin-bottom: 3px;
}

.sidenav-toggler-line {
  position: relative;
  display: block;
  height: 2px;
  background-color: #fff;
}

.sidenav-toggler-line:not(:last-child) {
  margin-bottom: 3px;
}

.navbar-search-light .input-group {
  border-color: rgba(0, 0, 0, .6);
  background-color: rgba(255, 255, 255, .9);
}

.navbar-search .form-control {
  width: 250px;
  transition: all .15s cubic-bezier(.68, -.55, .265, 1.55);
  border: 0;
  border-left-color: currentcolor;
  border-left-style: none;
  border-left-width: 0px;
  background-color: transparent;
}

.navbar-search .input-group .input-group-text {
  padding-left: 1rem;
  border: 0;
  background-color: transparent;
}

.navbar-search .input-group {
  transition: background-color .3s linear;
  transition-delay: 0s;
  transition-delay: .15s;
  border: 0 solid;
  border-top-color: currentcolor;
  border-right-color: currentcolor;
  border-bottom-color: currentcolor;
  border-left-color: currentcolor;
  border-radius: 2rem;
}

.breadcrumb-links {
  margin: 0;
  padding: 0;
  background: 0 0;
}

.breadcrumb-dark .breadcrumb-item {
  font-weight: 600;
}

.breadcrumb-item {
  font-size: .875rem;
}

.breadcrumb-dark .breadcrumb-item a {
  color: #f6f9fc;
}

.breadcrumb-dark .breadcrumb-item.active {
  color: #dee2e6;
}

.card {
  margin-bottom: 30px;
  border: 0;
  box-shadow: 0 0 2rem 0 rgba(136, 152, 170, .15);
}

.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  border: 1px solid rgba(0, 0, 0, .05);
  border-radius: .375rem;
  background-color: #fff;
  background-clip: border-box;
}

.card-stats {
  height: 100%;
  margin-bottom: 0px;
}

.card-stats .card-body {
  padding: 1rem 1rem;
}

.card-body {
  min-height: 1px;
  padding: 1.5rem;
  flex: 1 1 auto;
}

.card .h2 {
  color: #32325d;
}

.border-bottom {
  border-bottom: 1px solid #e9ecef !important;
  border-bottom-color: rgb(233, 236, 239);
}

.main-content .container-fluid,
.main-content .container-lg,
.main-content .container-md,
.main-content .container-sm,
.main-content .container-xl {
  padding-right: 30px !important;
  padding-left: 30px !important;
}

.mt--6,
.my--6 {
  margin-top: -4.5rem !important;
}

.pb-6,
.py-6 {
  padding-bottom: 4.5rem !important;
}

.card-header:first-child {
  border-radius: calc(.375rem - 1px) calc(.375rem - 1px) 0 0;
}

.card-header {
  margin-bottom: 0;
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid rgba(0, 0, 0, .05);
  background-color: #fff;
}

.card-img,
.card-img-top {
  border-top-left-radius: calc(.375rem - 1px);
  border-top-right-radius: calc(.375rem - 1px);
}

.card-img,
.card-img-bottom,
.card-img-top {
  width: 100%;
  flex-shrink: 0;
}

.card-profile-image {
  position: relative;
}

.card-profile-image img {
  position: absolute;
  left: 50%;
  max-width: 140px;
  transition: all .15s ease;
  transform: translate(-50%, -50%) scale(1);
  border: 3px solid #fff;
  border-radius: .375rem;
}

.card-profile-stats {
  padding: 1rem 0;
}

.card-profile-stats>div {
  margin-right: 1rem;
  padding: .875rem;
  text-align: center;
}

.card-profile-stats>div .heading {
  font-size: 1.1rem;
  font-weight: 700;
  display: block;
}

.card-profile-stats>div .description {
  font-size: .875rem;
  color: #adb5bd;
}

.font-weight-300 {
  font-weight: 300 !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

.avatar-sm {
  width: 36px !important;
  height: 36px !important;
  font-size: .875rem;
}

.avatar {
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  border-radius: .75rem;
  height: 48px;
  width: 48px;
  transition: all .2s ease-in-out;
}

.avatar img {
  width: 100%;
}

.w-75 {
  width: 75% !important;
}

.text-xs {
  font-size: .75rem !important;
}

.table td .progress {
  height: 3px;
  width: 120px;
  margin: 0;
}

.avatar-group .avatar+.avatar {
  margin-left: -1rem;
}

.avatar-group .avatar {
  position: relative;
  z-index: 2;
  border: 2px solid #fff;
}

.avatar-xs {
  width: 24px !important;
  height: 24px !important;
  font-size: .75rem;
}

.avatar.rounded-circle img,
.rounded-circle {
  border-radius: 50% !important;
}

.text-sm {
  font-size: .875rem !important;
}

.timeline {
  position: relative;
}

.timeline-one-side .timeline-step,
.timeline-one-side::before {
  left: 1rem;
}

.timeline::before {
  left: 50%;
  margin-left: -1px;
}

.timeline::before {
  content: "";
  position: absolute;
  top: 0;
  left: 1rem;
  height: 100%;
  border-right: 2px solid #dee2e6;
}

.timeline-block:first-child {
  margin-top: 0;
}

.timeline-one-side .timeline-step,
.timeline-one-side::before {
  left: 1rem;
}

.timeline-step {
  left: 50%;
}

.timeline-step {
  position: absolute;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  left: 0;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: #fff;
  text-align: center;
  transform: translateX(-50%);
  font-size: 1rem;
  font-weight: 600;
  z-index: 1;
}

.timeline-one-side .timeline-content {
  max-width: 30rem;
}

.timeline-one-side .timeline-content {
  width: auto;
}

.timeline-content {
  width: 38%;
}

.timeline-content {
  margin-left: 45px;
  padding-top: .35rem;
  position: relative;
  top: -6px;
}

.text-gradient.text-success {
  background-image: linear-gradient(310deg, #17ad37, #c1e823);
}

.timeline-step i,
.timeline-step svg {
  line-height: 1.4;
}

.text-gradient {
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  position: relative;
  z-index: 1;
}

.text-gradient.text-danger {
  background-image: linear-gradient(310deg, #d60808, #ff6690);
}

.timeline-step i,
.timeline-step svg {
  line-height: 1.4;
}

.text-gradient.text-info {
  background-image: linear-gradient(310deg, #2152ff, #21d4fd);
}

.text-gradient.text-warning {
  background-image: linear-gradient(310deg, #f53939, #fbcf33);
}

a:not([href]):not([class]) {
  color: #fff !important;
  text-decoration: none;
}

@media only screen and (max-width: 600px) {
  .sidenav.fixed-left+.main-content {
    margin-left: 0;
  }
}

.card-title {
  font-size: 16px;
}

.mobile-sidebar-slide {
  position: absolute;
  top: 0;
  left: 0;
  width: 250px;
  height: 100vh;
  background-color: #343a40;
  /* dark sidebar */
  z-index: 1000;
  animation: slideInLeft 0.3s ease forwards;
  color: white;
  padding: 1rem;
}

@keyframes slideInLeft {
  0% {
    transform: translateX(-100%);
    opacity: 0;
  }

  100% {
    transform: translateX(0);
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/Pages/Dashboard/dashboard.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,MAAM;EACN,SAAS;EACT,WAAW;EACX,+BAA+B;EAC/B,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,qFAAqF;AACvF;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;wBACsB;IACpB,sBAAsB;EACxB,2BAA2B;AAC7B;;AAEA;;GAEG;;AAEH;;GAEG;;AAEH;EACE,gBAAgB;EAChB,4CAA4C;EAC5C,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;AACA;AACA,kBAAkB;AAClB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,8DAA8D;AAChE;;;AAGA;EACE,cAAc;EACd,8DAA8D;AAChE;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,uHAAuH;AACzH;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,WAAW;EACX,YAAY;EACZ,WAAW;EACX,wDAAwD;EACxD,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,wDAAwD;EACxD,SAAS;EACT,+BAA+B;EAC/B,uBAAuB;EACvB,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,6BAA6B;AAC/B;;AAEA;EACE,uCAAuC;EACvC,oBAAoB;EACpB,sBAAsB;EACtB,eAAe;EACf,8BAA8B;EAC9B,gCAAgC;EAChC,iCAAiC;EACjC,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;EACrB,oCAAoC;EACpC,sBAAsB;EACtB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2CAA2C;EAC3C,uCAAuC;AACzC;;AAEA;;;;;EAKE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA;;EAEE,2CAA2C;EAC3C,4CAA4C;AAC9C;;AAEA;;;EAGE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,yBAAyB;EACzB,yCAAyC;EACzC,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,OAAO;EACP,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,oCAAoC;EACpC,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,yCAAyC;EACzC,YAAY;EACZ,aAAa;AACf;;AAEA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;;EAEA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF","sourcesContent":[".bg-gray-100 {\r\n  background-color: #f8f9fa !important;\r\n}\r\n\r\n.topbar {\r\n  background: #000;\r\n}\r\n\r\n.navbar-vertical.navbar-expand-xs.fixed-left {\r\n  left: 0;\r\n}\r\n\r\n.custom-col-spacing {\r\n  margin-right: 0rem;\r\n  /* Adjust this value to reduce space */\r\n  margin-left: 0rem;\r\n  /* Adjust this value to reduce space */\r\n}\r\n\r\n.navbar-vertical.navbar-expand-xs {\r\n  display: block;\r\n  position: fixed;\r\n  top: 0;\r\n  bottom: 0;\r\n  width: 100%;\r\n  max-width: 15.625rem !important;\r\n  overflow-y: auto;\r\n  padding: 0;\r\n  box-shadow: none;\r\n  background-color: #292f36;\r\n}\r\n\r\n.sidenav {\r\n  z-index: 1050;\r\n}\r\n\r\n.main-content,\r\n.sidenav {\r\n  transition: all .2s ease-in-out;\r\n}\r\n\r\n.sidenav-header {\r\n  height: 4.875rem;\r\n}\r\n\r\n.navbar-vertical .navbar-brand-img,\r\n.navbar-vertical .navbar-brand>img {\r\n  max-width: 100%;\r\n  max-height: 2rem;\r\n}\r\n\r\n.w-15 {\r\n  width: 15% !important;\r\n}\r\n\r\n.sidenav .navbar-brand {\r\n  padding: 1.5rem 2rem;\r\n}\r\n\r\n.sidenav .navbar-brand,\r\n.sidenav .navbar-heading {\r\n  display: block;\r\n}\r\n\r\n.navbar .nav-link,\r\n.navbar .navbar-brand {\r\n  color: #252f40;\r\n  font-size: .875rem;\r\n}\r\n\r\nhr.horizontal.dark {\r\n  background-image: linear-gradient(90deg, transparent, rgba(0, 0, 0, .4), transparent);\r\n}\r\n\r\nhr.horizontal {\r\n  background-color: transparent;\r\n}\r\n\r\nhr:not([size]) {\r\n  height: 1px;\r\n}\r\n\r\n.navbar-vertical.navbar-expand-xs .navbar-collapse {\r\n  display: block;\r\n  overflow: auto;\r\n}\r\n\r\n.navbar-nav {\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding-left: 0;\r\n  margin-bottom: 0;\r\n  list-style: none;\r\n}\r\n\r\n.navbar-vertical.navbar-expand-xs .navbar-nav>.nav-item {\r\n  margin-top: .125rem;\r\n}\r\n\r\n.navbar-vertical.navbar-expand-xs .navbar-nav .nav-item {\r\n  width: 100%;\r\n}\r\n\r\n.navbar-vertical .navbar-nav>.nav-item .nav-link.active {\r\n  /* color: #000;\r\n  background: #fde802; */\r\n    color: #fff !important;\r\n  background: #f40 !important;\r\n}\r\n\r\n/* .nav-item li{\r\nbackground: #000;\r\n} */\r\n\r\n/* .nav-item li.active{\r\nbackground: #fde802;\r\n} */\r\n\r\n.navbar-vertical .navbar-nav .nav-link.active {\r\n  font-weight: 600;\r\n  box-shadow: 0 20px 27px 0 rgba(0, 0, 0, .05);\r\n  border-radius: .5rem;\r\n}\r\n\r\n.navbar-vertical.navbar-expand-xs .navbar-nav .nav-link {\r\n  padding-top: .675rem;\r\n  padding-bottom: .675rem;\r\n  margin: 0 1rem;\r\n}\r\n\r\n.navbar-vertical .navbar-nav .nav-link {\r\n  display: flex;\r\n  align-items: center;\r\n  white-space: nowrap;\r\n  text-decoration: none;\r\n}\r\n\r\n.bg-color {\r\n  background: #000;\r\n  min-height: 100vh;\r\n}\r\n\r\n.header-bg {\r\n  background: #000;\r\n}\r\n.card-style{\r\nbackground:#565b60;\r\n}\r\n.navbar-vertical .navbar-nav .nav-link {\r\n  padding-left: 1rem;\r\n  padding-right: 1rem;\r\n  font-weight: 600;\r\n  color: #fff;\r\n}\r\n\r\n.navbar-vertical .navbar-nav>.nav-item .nav-link .icon {\r\n  color: #000;\r\n  /* color: linear-gradient(180deg, #E4AE75 0%, #99663A 100%); */\r\n}\r\n\r\n\r\n.navbar-vertical .navbar-nav>.nav-item .nav-link.active .icon {\r\n  color: #fde802;\r\n  /* color: linear-gradient(180deg, #E4AE75 0%, #99663A 100%); */\r\n}\r\n\r\n.border-radius-md {\r\n  border-radius: .5rem;\r\n}\r\n\r\n.icon-sm {\r\n  width: 32px;\r\n  height: 32px;\r\n}\r\n\r\n.me-2 {\r\n  margin-right: .5rem !important;\r\n}\r\n\r\n.shadow {\r\n  box-shadow: 0 .25rem .375rem -.0625rem hsla(0, 0%, 8%, .12), 0 .125rem .25rem -.0625rem hsla(0, 0%, 8%, .07) !important;\r\n}\r\n\r\n.sidenav.fixed-left+.main-content {\r\n  margin-left: 15.6rem;\r\n}\r\n\r\n.main-content,\r\n.sidenav {\r\n  transition: all .2s ease-in-out;\r\n}\r\n\r\n.border-radius-lg {\r\n  border-radius: .75rem;\r\n}\r\n\r\n.font-weight-bolder {\r\n  font-weight: 700 !important;\r\n}\r\n\r\n.sidenav .sidenav-toggler {\r\n  width: 50px;\r\n  float: right;\r\n  margin-top: 2rem;\r\n}\r\n\r\n.sidenav-toggler .sidenav-toggler-line:last-child {\r\n  width: 13px;\r\n  transform: translateX(5px);\r\n}\r\n\r\n.sidenav-toggler-inner {\r\n  position: relative;\r\n}\r\n\r\n.sidenav-toggler-inner,\r\n.sidenav-toggler-line {\r\n  width: 18px;\r\n  transition: all .15s ease;\r\n}\r\n\r\n.sidenav-toggler .sidenav-toggler-inner::before {\r\n  transform: scale(1);\r\n}\r\n\r\n.sidenav-toggler-inner::before {\r\n  position: absolute;\r\n  top: -14px;\r\n  left: -11px;\r\n  width: 40px;\r\n  height: 40px;\r\n  content: '';\r\n  transition: all .15s cubic-bezier(.68, -.55, .265, 1.55);\r\n  transform: scale(0);\r\n  border-radius: 50%;\r\n}\r\n\r\n.sidenav-toggler.active .sidenav-toggler-line:first-child {\r\n  width: 13px;\r\n  transform: translateX(5px);\r\n}\r\n\r\n.sidenav-toggler-line:not(:last-child) {\r\n  margin-bottom: 3px;\r\n}\r\n\r\n.sidenav-toggler-line {\r\n  position: relative;\r\n  display: block;\r\n  height: 2px;\r\n  background-color: #fff;\r\n}\r\n\r\n.sidenav-toggler-line:not(:last-child) {\r\n  margin-bottom: 3px;\r\n}\r\n\r\n.navbar-search-light .input-group {\r\n  border-color: rgba(0, 0, 0, .6);\r\n  background-color: rgba(255, 255, 255, .9);\r\n}\r\n\r\n.navbar-search .form-control {\r\n  width: 250px;\r\n  transition: all .15s cubic-bezier(.68, -.55, .265, 1.55);\r\n  border: 0;\r\n  border-left-color: currentcolor;\r\n  border-left-style: none;\r\n  border-left-width: 0px;\r\n  background-color: transparent;\r\n}\r\n\r\n.navbar-search .input-group .input-group-text {\r\n  padding-left: 1rem;\r\n  border: 0;\r\n  background-color: transparent;\r\n}\r\n\r\n.navbar-search .input-group {\r\n  transition: background-color .3s linear;\r\n  transition-delay: 0s;\r\n  transition-delay: .15s;\r\n  border: 0 solid;\r\n  border-top-color: currentcolor;\r\n  border-right-color: currentcolor;\r\n  border-bottom-color: currentcolor;\r\n  border-left-color: currentcolor;\r\n  border-radius: 2rem;\r\n}\r\n\r\n.breadcrumb-links {\r\n  margin: 0;\r\n  padding: 0;\r\n  background: 0 0;\r\n}\r\n\r\n.breadcrumb-dark .breadcrumb-item {\r\n  font-weight: 600;\r\n}\r\n\r\n.breadcrumb-item {\r\n  font-size: .875rem;\r\n}\r\n\r\n.breadcrumb-dark .breadcrumb-item a {\r\n  color: #f6f9fc;\r\n}\r\n\r\n.breadcrumb-dark .breadcrumb-item.active {\r\n  color: #dee2e6;\r\n}\r\n\r\n.card {\r\n  margin-bottom: 30px;\r\n  border: 0;\r\n  box-shadow: 0 0 2rem 0 rgba(136, 152, 170, .15);\r\n}\r\n\r\n.card {\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-width: 0;\r\n  word-wrap: break-word;\r\n  border: 1px solid rgba(0, 0, 0, .05);\r\n  border-radius: .375rem;\r\n  background-color: #fff;\r\n  background-clip: border-box;\r\n}\r\n\r\n.card-stats {\r\n  height: 100%;\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.card-stats .card-body {\r\n  padding: 1rem 1rem;\r\n}\r\n\r\n.card-body {\r\n  min-height: 1px;\r\n  padding: 1.5rem;\r\n  flex: 1 1 auto;\r\n}\r\n\r\n.card .h2 {\r\n  color: #32325d;\r\n}\r\n\r\n.border-bottom {\r\n  border-bottom: 1px solid #e9ecef !important;\r\n  border-bottom-color: rgb(233, 236, 239);\r\n}\r\n\r\n.main-content .container-fluid,\r\n.main-content .container-lg,\r\n.main-content .container-md,\r\n.main-content .container-sm,\r\n.main-content .container-xl {\r\n  padding-right: 30px !important;\r\n  padding-left: 30px !important;\r\n}\r\n\r\n.mt--6,\r\n.my--6 {\r\n  margin-top: -4.5rem !important;\r\n}\r\n\r\n.pb-6,\r\n.py-6 {\r\n  padding-bottom: 4.5rem !important;\r\n}\r\n\r\n.card-header:first-child {\r\n  border-radius: calc(.375rem - 1px) calc(.375rem - 1px) 0 0;\r\n}\r\n\r\n.card-header {\r\n  margin-bottom: 0;\r\n  padding: 1.25rem 1.5rem;\r\n  border-bottom: 1px solid rgba(0, 0, 0, .05);\r\n  background-color: #fff;\r\n}\r\n\r\n.card-img,\r\n.card-img-top {\r\n  border-top-left-radius: calc(.375rem - 1px);\r\n  border-top-right-radius: calc(.375rem - 1px);\r\n}\r\n\r\n.card-img,\r\n.card-img-bottom,\r\n.card-img-top {\r\n  width: 100%;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.card-profile-image {\r\n  position: relative;\r\n}\r\n\r\n.card-profile-image img {\r\n  position: absolute;\r\n  left: 50%;\r\n  max-width: 140px;\r\n  transition: all .15s ease;\r\n  transform: translate(-50%, -50%) scale(1);\r\n  border: 3px solid #fff;\r\n  border-radius: .375rem;\r\n}\r\n\r\n.card-profile-stats {\r\n  padding: 1rem 0;\r\n}\r\n\r\n.card-profile-stats>div {\r\n  margin-right: 1rem;\r\n  padding: .875rem;\r\n  text-align: center;\r\n}\r\n\r\n.card-profile-stats>div .heading {\r\n  font-size: 1.1rem;\r\n  font-weight: 700;\r\n  display: block;\r\n}\r\n\r\n.card-profile-stats>div .description {\r\n  font-size: .875rem;\r\n  color: #adb5bd;\r\n}\r\n\r\n.font-weight-300 {\r\n  font-weight: 300 !important;\r\n}\r\n\r\n.text-nowrap {\r\n  white-space: nowrap !important;\r\n}\r\n\r\n.avatar-sm {\r\n  width: 36px !important;\r\n  height: 36px !important;\r\n  font-size: .875rem;\r\n}\r\n\r\n.avatar {\r\n  color: #fff;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 1rem;\r\n  border-radius: .75rem;\r\n  height: 48px;\r\n  width: 48px;\r\n  transition: all .2s ease-in-out;\r\n}\r\n\r\n.avatar img {\r\n  width: 100%;\r\n}\r\n\r\n.w-75 {\r\n  width: 75% !important;\r\n}\r\n\r\n.text-xs {\r\n  font-size: .75rem !important;\r\n}\r\n\r\n.table td .progress {\r\n  height: 3px;\r\n  width: 120px;\r\n  margin: 0;\r\n}\r\n\r\n.avatar-group .avatar+.avatar {\r\n  margin-left: -1rem;\r\n}\r\n\r\n.avatar-group .avatar {\r\n  position: relative;\r\n  z-index: 2;\r\n  border: 2px solid #fff;\r\n}\r\n\r\n.avatar-xs {\r\n  width: 24px !important;\r\n  height: 24px !important;\r\n  font-size: .75rem;\r\n}\r\n\r\n.avatar.rounded-circle img,\r\n.rounded-circle {\r\n  border-radius: 50% !important;\r\n}\r\n\r\n.text-sm {\r\n  font-size: .875rem !important;\r\n}\r\n\r\n.timeline {\r\n  position: relative;\r\n}\r\n\r\n.timeline-one-side .timeline-step,\r\n.timeline-one-side::before {\r\n  left: 1rem;\r\n}\r\n\r\n.timeline::before {\r\n  left: 50%;\r\n  margin-left: -1px;\r\n}\r\n\r\n.timeline::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 0;\r\n  left: 1rem;\r\n  height: 100%;\r\n  border-right: 2px solid #dee2e6;\r\n}\r\n\r\n.timeline-block:first-child {\r\n  margin-top: 0;\r\n}\r\n\r\n.timeline-one-side .timeline-step,\r\n.timeline-one-side::before {\r\n  left: 1rem;\r\n}\r\n\r\n.timeline-step {\r\n  left: 50%;\r\n}\r\n\r\n.timeline-step {\r\n  position: absolute;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  left: 0;\r\n  width: 26px;\r\n  height: 26px;\r\n  border-radius: 50%;\r\n  background: #fff;\r\n  text-align: center;\r\n  transform: translateX(-50%);\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n  z-index: 1;\r\n}\r\n\r\n.timeline-one-side .timeline-content {\r\n  max-width: 30rem;\r\n}\r\n\r\n.timeline-one-side .timeline-content {\r\n  width: auto;\r\n}\r\n\r\n.timeline-content {\r\n  width: 38%;\r\n}\r\n\r\n.timeline-content {\r\n  margin-left: 45px;\r\n  padding-top: .35rem;\r\n  position: relative;\r\n  top: -6px;\r\n}\r\n\r\n.text-gradient.text-success {\r\n  background-image: linear-gradient(310deg, #17ad37, #c1e823);\r\n}\r\n\r\n.timeline-step i,\r\n.timeline-step svg {\r\n  line-height: 1.4;\r\n}\r\n\r\n.text-gradient {\r\n  background-clip: text;\r\n  -webkit-background-clip: text;\r\n  -webkit-text-fill-color: transparent;\r\n  position: relative;\r\n  z-index: 1;\r\n}\r\n\r\n.text-gradient.text-danger {\r\n  background-image: linear-gradient(310deg, #d60808, #ff6690);\r\n}\r\n\r\n.timeline-step i,\r\n.timeline-step svg {\r\n  line-height: 1.4;\r\n}\r\n\r\n.text-gradient.text-info {\r\n  background-image: linear-gradient(310deg, #2152ff, #21d4fd);\r\n}\r\n\r\n.text-gradient.text-warning {\r\n  background-image: linear-gradient(310deg, #f53939, #fbcf33);\r\n}\r\n\r\na:not([href]):not([class]) {\r\n  color: #fff !important;\r\n  text-decoration: none;\r\n}\r\n\r\n@media only screen and (max-width: 600px) {\r\n  .sidenav.fixed-left+.main-content {\r\n    margin-left: 0;\r\n  }\r\n}\r\n\r\n.card-title {\r\n  font-size: 16px;\r\n}\r\n\r\n.mobile-sidebar-slide {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 250px;\r\n  height: 100vh;\r\n  background-color: #343a40;\r\n  /* dark sidebar */\r\n  z-index: 1000;\r\n  animation: slideInLeft 0.3s ease forwards;\r\n  color: white;\r\n  padding: 1rem;\r\n}\r\n\r\n@keyframes slideInLeft {\r\n  0% {\r\n    transform: translateX(-100%);\r\n    opacity: 0;\r\n  }\r\n\r\n  100% {\r\n    transform: translateX(0);\r\n    opacity: 1;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
